'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { Delete02Icon } from '@terra/ui-icons';
import { IconButton } from '../../../components/icon-button';
import { MetaDefault } from '../../../components/typography';

export type ApplicationDocumentationUrlListProps = {
  urls: string[];
  onRemoveUrl: ({ urlIndex }: { urlIndex: number }) => void;
  deleteAriaLabel: string;
  omitUrlRowIndex?: number | null;
  isReadOnly?: boolean;
};

export const ApplicationDocumentationUrlList = ({
  urls,
  onRemoveUrl,
  deleteAriaLabel,
  omitUrlRowIndex = null,
  isReadOnly,
}: ApplicationDocumentationUrlListProps) => {
  if (urls.length === 0) {
    return null;
  }

  return (
    <VStack alignItems="stretch" gap={3} w="full">
      {urls.map((url, urlIndex) =>
        omitUrlRowIndex === urlIndex ? null : (
          <HStack
            key={`documentation-url-${urlIndex}-${url}`}
            w="full"
            justifyContent="space-between"
            alignItems="center"
            gap="24px"
            bg="bg.neutral.light"
            borderWidth="1px"
            borderColor="border.neutral.subtle"
            borderRadius="md"
            px={3}
            py={3}
          >
            <MetaDefault color="fg.neutral.default" truncate flex={1} minW={0}>
              {url}
            </MetaDefault>
            {!isReadOnly && (
              <IconButton
                variant="ghost"
                size="sm"
                flexShrink={0}
                color="fg.neutral.default"
                aria-label={deleteAriaLabel}
                onClick={() => onRemoveUrl({ urlIndex })}
              >
                <Delete02Icon size={16} />
              </IconButton>
            )}
          </HStack>
        ),
      )}
    </VStack>
  );
};
